import React, { Component } from 'react'
import { connect } from 'react-redux'
import AuthorizeSimLogin from '../../../components/authentication/oauth/AuthorizeSimLogin'

class AuthorizeSimLoginPage extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    console.log('render..')
    return (<AuthorizeSimLogin />)
  }
}

export default connect(
  store => ({
    user: store.authen != null && store.authen.user != null ? store.authen.user : null,
    messages: store.theme.messages,
    locale: store.theme.locale,
  }),
  {},
)(AuthorizeSimLoginPage)
